import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { setNudgeIntentAnalyticsEnabled } from 'src/components/modals/phone-verification-nudge/nudge-intent-marker-analytics';
import { PHONE_VERIFICATION_NUDGE_ANALYTICS_FLAG } from './use-phone-verification-nudge-analytics';

/**
 * Mounts the same `ecomm.phone-identity.nudge-analytics.rollout` flag that gates every other
 * phoneVerificationNudgeAction emission into the module-level mirror that
 * `nudge-intent-marker-analytics.ts` reads from -- that module's `setNudgeIntentMarker` call
 * sites include a plain, non-React file (`state/actions/users.js`) that cannot call `useFlags`
 * itself. Mounted once from `GlobalControllers`, alongside `useFeatureFlagsController`.
 */
export function usePhoneVerificationNudgeIntentAnalyticsFlag(): void {
  const flags = useFlags();
  const isEnabled = flags[PHONE_VERIFICATION_NUDGE_ANALYTICS_FLAG] ?? false;

  useEffect(() => {
    setNudgeIntentAnalyticsEnabled(isEnabled);
  }, [isEnabled]);
}
